import { DataCollectionScene } from './widgets/DataCollectionScene';
import { FrequencyTable } from './widgets/FrequencyTable';
import { GraphPlotter } from './widgets/GraphPlotter';
import { InterpretationPanel } from './widgets/InterpretationPanel';
import { NarrationPlayer } from './widgets/NarrationPlayer';
import { ProgressMeter } from './widgets/ProgressMeter';
/**
 * The widget registry.
 *
 * Six widgets, which between them cover the Data Handling lab and a large share
 * of maths and science data labs: observe a phenomenon, tabulate it, plot it,
 * reason about the plot — plus the narration and progress chrome that the
 * script's UI Layers ask for on every step.
 *
 * Adding a widget is two edits: a variant in `@stem/lab-schema`'s `labStage`
 * union, and an entry here. Nothing else in the runtime knows what a widget is.
 */
export const STAGE_WIDGETS = {
    DataCollectionScene,
    FrequencyTable,
    GraphPlotter,
    InterpretationPanel,
};
export const CHROME_WIDGETS = {
    NarrationPlayer,
    ProgressMeter,
};
export function resolveStageWidget(name) {
    return STAGE_WIDGETS[name];
}
export { DataCollectionScene, FrequencyTable, GraphPlotter, InterpretationPanel, NarrationPlayer, ProgressMeter, };
//# sourceMappingURL=registry.js.map